// §29.11 / §9.1 — Sortie as an in-process app.
//
// Gated like the rest of the Arcade (D-359); manifest only (D-247). A **factory**, for the same
// reason Intercept is one: §30.1 puts Sortie on the multiplayer allowlist, and the co-op half of
// §26.7 needs a session that `HangarAPI` does not carry.
import type { InProcessApp, PlayShellAccess } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';

export function createSortieApp(play: PlayShellAccess): InProcessApp {
  return createLazyApp<{ play: PlayShellAccess }>({
    app: {
      id: 'sortie',
      name: 'Sortie',
      icon: { glyph: 'plane', hue: 210 },
      keywords: ['shooter', 'plane', 'co-op', 'coop', 'scroll', 'game', 'arcade'],
      category: 'Arcade',
      // §29.1 (D-369) — the sub-group header this title sits under in the launcher and the Store.
      group: 'Action',
      requiresAuth: true,
      // Fixed 3:4 portrait, letterboxed (D-229, D-374). Sortie is 240 × 320 and the field's width
      // is the difficulty — a wide window would hand a player room to dodge that the wave tables
      // were not authored against, and in co-op it would hand it to only one of them.
      window: { width: 560, height: 780, minWidth: 380, minHeight: 520, multiWindow: false },
      jumpList: [{ id: 'new-game', label: 'New game' }],
    },
    load: () => import('./Sortie'),
    props: { play },
  });
}
